import React from 'react';
import PropTypes from 'prop-types';
import { ButtonAction, Lines } from './style';

const ButtonActions = ({
  className,
  text,
  selected,
  onClick,
  menuWithScroll
}) => (
  <ButtonAction
    className={className}
    onClick={onClick}
    menuWithScroll={menuWithScroll}
  >
    <Lines selected={selected} />
    {text}
  </ButtonAction>
);

ButtonActions.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  menuWithScroll: PropTypes.bool
};

ButtonActions.defaultProps = {
  text: 'Mis cosas',
  selected: false,
  onClick: undefined
};

export default ButtonActions;
